import lodash from 'lodash';

export const setRules = (rules , pro, proIndex) => {
    let product  = lodash.cloneDeep(pro);
    const additionalPrice = product.additionalPrice;

    rules.map((rule, index) => {

        if (!rule.isEnabled) { return null; }

        switch(rule.key) {
            case 'FirstProductFree':
                if(proIndex == 0){
                    product.additionalPrice = 0;
                }       
            break;
            case 'SecondProductFree':
                if(proIndex == 1){
                    product.additionalPrice = 0;
                } 
            break;
            case 'ThirdProductFree':
                if(proIndex == 2){
                    product.additionalPrice = 0;
                } 
            break;
            case 'FirstProductDiscount':
                if(proIndex == 0){
                    product.additionalPrice = additionalPrice - rule.value;
                } 
            break;                
            case 'SecondProductDiscount':
                if(proIndex == 1){
                    product.additionalPrice = additionalPrice - rule.value;
                } 
            break;
            case 'ThirdProductDiscount':
                if(proIndex == 2){
                    product.additionalPrice = additionalPrice - rule.value;
                }
            break;
            case 'MoreThanOneProductsDiscount':
                if(proIndex > 0){
                    product.additionalPrice = additionalPrice - rule.value;
                }
            break;
            case 'MoreThanTwoProductsDiscount':
                if(proIndex > 1){
                    product.additionalPrice = additionalPrice - rule.value;
                }
            break; 
            case 'MoreThanThreeProductsDiscount':
                if(proIndex > 2){
                    product.additionalPrice = additionalPrice - rule.value;
                }
            break;                                               
            default:
        }
    });    

    return product;
  };